export enum ActionType {
  InAndOut = 0,
  In = 1,
  Out = 2,
}
export enum ActionTypeContext {
  InAndOut = 'Chặn 2 chiều',
  In = 'Chặn gọi vào',
  Out = 'Chặn gọi ra',
}
export class BlacklistConst {
  static displayColumns = () => {
    return [
      {
        title: 'Đầu số/email chặn',
        key: 'data',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Kiểu',
        key: 'display_type',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static actionTypeArray = () => {
    return [
      { id: ActionType.InAndOut.toString(), text: ActionTypeContext.InAndOut },
      { id: ActionType.In.toString(), text: ActionTypeContext.In },
      { id: ActionType.Out.toString(), text: ActionTypeContext.Out },
    ];
  };
  static actionTypeTableString = type => {
    switch (type) {
      case ActionType.InAndOut:
      case ActionType.InAndOut.toString():
        return `<small class="badge badge-default">` + ActionTypeContext.InAndOut + `</small>`;
      case ActionType.In:
      case ActionType.In.toString():
        return `<small class="badge badge-default">` + ActionTypeContext.In + `</small>`;
      case ActionType.Out:
      case ActionType.Out.toString():
        return `<small class="badge badge-default">` + ActionTypeContext.Out + `</small>`;
      default:
        return `<small class="badge badge-default">` + type + `</small>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/blacklist/blacklist.const.ts